import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Sheet, SheetContent, SheetClose } from "@/components/ui/sheet";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { CloseButton, useIsMobile } from "@/components/shared/PagePrimitives";
import { useDetailNav, DetailNav } from "@/components/shared/ListNav";

// 355: kontrola docházky (směna i denní výkaz) — na počítači a tabletu panel zprava jako detail faktury
// v Dokladech, na telefonu dál okno zespodu. nav = { index, count, onGo }: ↑ ↓ další záznam fronty,
// mezerník zavře (Esc zavírá samo). Rozepsané úpravy se před přechodem klávesou zeptají.
// children(controls): controls = „2 / 5 ↑ ↓ ✕" do hlavičky (na telefonu null — okno má vlastní ✕).
// 356: i detail úkolu (noun „úkol“, podklad stránky — karty úkolu jsou bílé).
export function ReviewPanel({ open, onClose, nav = null, dirty = false, testid, title, mobileClass = "", onInteractOutside, noun = "záznam", bg = "bg-card", children }) {
  const mobile = useIsMobile();
  const [ask, setAsk] = useState(null);   // { run } — co udělat po „Zahodit“
  // 382: sklo panelu až po dojetí (během vyjetí plný — rozostření v pohybu brzdí slabší počítače)
  const [settled, setSettled] = useState(false);
  useEffect(() => { if (!open) setSettled(false); }, [open]);
  const guard = (fn) => (dirty ? setAsk({ run: fn }) : fn());
  const keys = nav ? { ...nav, onGo: (i) => guard(() => nav.onGo(i)) } : { index: 0, count: 1, onGo() {} };
  useDetailNav(open && !mobile ? keys : null, open && !ask, () => guard(() => onClose?.()));
  const onOpenChange = (o) => { if (!o) onClose?.(); };
  const label = title ? <DialogTitle className="sr-only">{title}</DialogTitle> : null;

  const confirm = (
    <AlertDialog open={!!ask} onOpenChange={(o) => { if (!o) setAsk(null); }}>
      <AlertDialogContent data-testid="review-discard-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>Zahodit rozepsané úpravy?</AlertDialogTitle>
          <AlertDialogDescription>Změny časů a popisu se neuloží.</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <Button variant="outline" onClick={() => setAsk(null)} className="h-11 w-full sm:w-auto">Zpět</Button>
          <Button variant="destructive" onClick={() => { const a = ask; setAsk(null); a?.run(); }} className="h-11 w-full sm:w-auto font-bold" data-testid="review-discard-confirm">Zahodit</Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  if (mobile) {
    return (<>
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent sheet data-testid={testid} aria-describedby={undefined} onOpenAutoFocus={(e) => e.preventDefault()} onInteractOutside={onInteractOutside}
          className={`p-0 max-md:pb-0 gap-0 overflow-hidden grid-rows-[auto_minmax(0,1fr)_auto] ${mobileClass}`}>
          {label}{children(null)}
        </DialogContent>
      </Dialog>
      {confirm}
    </>);
  }
  const controls = (
    <div className="flex items-center gap-1.5 shrink-0" data-testid="review-controls">
      <DetailNav nav={nav} testid="review-nav" noun={noun} />
      <SheetClose asChild><CloseButton testid="review-close" /></SheetClose>
    </div>
  );
  return (<>
    <Sheet open={open} onOpenChange={onOpenChange}>
      {/* kurzor do panelu (ne do pole): mezerník a šipky pak patří detailu, ne seznamu pod ním */}
      {/* 361: Esc při úpravě názvu / popisu na místě vrátí text, panel nezavře */}
      <SheetContent side="right" hideClose data-testid={testid} aria-describedby={undefined} onInteractOutside={onInteractOutside}
        onEscapeKeyDown={(e) => { if (document.activeElement?.closest?.("[data-inline-edit]")) e.preventDefault(); }}
        onOpenAutoFocus={(e) => { e.preventDefault(); e.currentTarget?.focus?.({ preventScroll: true }); }}
        onAnimationEnd={(e) => { if (e.target === e.currentTarget && open) setSettled(true); }}
        className={`p-0 border-0 inset-y-3 right-3 h-auto w-[min(720px,calc(100vw-24px))] sm:max-w-none rounded-[24px] ${bg} ${bg === "bg-card" ? "pp-glass-panel" : ""} ${settled ? "pp-settled" : ""} overflow-hidden grid grid-rows-[auto_minmax(0,1fr)_auto] gap-0 outline-none [&>*]:min-w-0`}>
        {label}{children(controls)}
      </SheetContent>
    </Sheet>
    {confirm}
  </>);
}
